import { useUserStore } from '../../store/useUserStore';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Url from '../../data/url';
import { useKidsQuery } from '../../queries';
import { calculateAge } from '../../utility/utilities';
import { useTranslation } from '../../hook/useTranslation';
import BottomTwoBtnDialog from '../common/BottomTwoBtnDialog';

function KidsReport() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const user = useUserStore();
  const setUser = user.setUser;
  const [openDialog, setOpenDialog] = useState(false);

  const { data: kids = [] } = useKidsQuery(user?.id, { enabled: !!user?.id });

  return (
    <div className="w-full my-[24px]">
      <div className="w-full flex items-center justify-between">
        <div className="flex items-center justify-start gap-2 text-left font-[700] text-[14px]">
          {t('my.kids_report.title')}
        </div>
      </div>
      <div style={{ width: '100vw', marginLeft: '-20px', marginRight: '-20px' }}>
        <div className="mt-[16px] flex items-center justify-start overflow-x-auto">
          <div className="shrink-0 pb-2 inline-flex items-center justify-start px-2 gap-[12px] pl-[20px]">
            {kids?.length >= 1 &&
              kids?.map((kid, index) => {
                return (
                  <button
                    type="button"
                    key={`${kid.id}-${index}`}
                    onClick={() => {
                      if (kid?.reports?.length >= 1) {
                        setUser((prev) => {
                          return { ...prev, mainKid: kid };
                        });
                        navigate(Url.Report);
                      } else {
                        setOpenDialog(true);
                      }
                    }}
                    className="min-w-[110px] min-h-[138px] bg-[#F8F8F8] border border-[#EAEAEA] flex flex-col items-center justify-center p-[20px] rounded-[24px]"
                  >
                    <div className="border overflow-hidden rounded-[50%] border-[#EAEAEA] bg-white w-[52px] h-[52px] flex items-center justify-center">
                      {kid?.imageUrl && (
                        <img
                          src={kid.imageUrl}
                          alt="thumnail1"
                          className="object-contain w-[52px] h-[52px]"
                          style={{ width: '52px', height: '52px', objectFit: 'cover' }}
                        />
                      )}
                    </div>
                    <div className="font-[600] text-[16px] text-[#1A1A1A]">{kid?.kidName}</div>
                    <div className="text-[12px] text-[#7D7D7D]">
                      {t('common.age', { age: calculateAge(kid?.kidBirth) })}
                    </div>
                  </button>
                );
              })}
          </div>
          <div className="shrink-0 w-[20px] h-[10px]" />
        </div>
        <BottomTwoBtnDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          title={t('my.kids_report.alert_title')}
          description={t('my.kids_report.alert_desc')}
          leftBtnText={t('common.cancel')}
          rightBtnText={t('my.kids_report.alert_btn')}
          leftBtnClick={() => setOpenDialog(false)}
          rightBtnClick={() => navigate(Url.KidsRegisterUpload)}
        />
      </div>
    </div>
  );
}

export default KidsReport;
